
import React, { useEffect, useState, useContext } from 'react'
import { PJAxios,usePJStore } from '@jaf/jaf-react-core'
import moment from 'moment/moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

function FaqDetail(props) {

    const [detail, setDetail] = useState(null);

    const getText = usePJStore((state) => state.i18n_getText)
    const { storage } = usePJStore((state) => state.storage)


    useEffect(() => {

        var url = '/gestioneConfigurazioni/getItemDetail/' + props.selectedNode.idItem;
        PJAxios().get(url).then((res) => {
            setDetail(res.data);

        });
    }, [props.selectedNode]);



    return (
        <>
            <div className="formgrid grid">

                {props.selectedNode.lastEdit &&
                    <>
                        <div className="col-12">
                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("ULTIMA_MODIFICA") + ": "}</b>{moment(props.selectedNode.lastEdit).format("DD-MM-YYYY hh:mm")}</h6></span>

                        </div>


                        <div>&nbsp;</div>

                        <div className="col-12">
                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("ID_NODO") + ": "}</b></h6>{props.selectedNode.idNode}</span>


                        </div>

                    </>

                }

                {detail && detail.tematiche && props.selectedNode.nodeType === 'Q' &&
                    <>
                        <div>&nbsp;</div>
                        <div className="col-12">
                            <span style={{ textAlign: "left", textTransform: "uppercase" }}><h6><b>{getText("TEMATICHE_PRESENZA_ITEM")}</b></h6></span>

                            <DataTable showGridlines size="small" stripedRows rows={100} value={detail.tematiche} responsiveLayout="scroll">
                                <Column className="centeredColumn" field="name" header={getText("TEMATICA")}></Column>
                            </DataTable>

                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default FaqDetail
